module.exports = __webpack_public_path__ + "static/media/starter.4116f81f.pdf";